import Api from '../../utils/API';
import { SagaIterator } from 'redux-saga';
import { call, put, select } from 'redux-saga/effects';
import { putAccessRules } from '../../actions';
import { getAccessRules } from '../../selectors/accessRules';

export const accessRulesSaga = function* (): SagaIterator {
  try {
    const accessRules = yield select(getAccessRules);
    yield put(putAccessRules({ ...accessRules, isLoadingAccessRules: true }));

    const { result: availableRules } = yield call(Api.AccessRules.get);
    const { result: planConfig } = yield call(Api.AccessRules.getPlanConfig);
    const { result: planUsage } = yield call(Api.AccessRules.getPlanUsage);

    // a failed call resolves without `result` and the reducer replaces the
    // whole slice — keep the previous values so nothing gets wiped
    yield put(
      putAccessRules({
        availableRules: availableRules || accessRules.availableRules,
        planConfig: planConfig || accessRules.planConfig,
        planUsage: planUsage || accessRules.planUsage,
        isLoadingAccessRules: false
      })
    );
  } catch (e) {
    console.error('Failed to track event', e);
  }
};
